import auth from './auth.js'

const authController = [...auth]

export default authController
